/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation, Trans } from 'react-i18next';
import SubmissionTable from '../../../../components/submissionOverview/SimpleSubmissionTable';
import Button from '../../../../components/common/Button';

function SendSubmissionDialog({ view, sendSubmissionDialog }) {
  const { t } = useTranslation();

  return (
    <>
      <Dialog open={sendSubmissionDialog.isOpen} fullWidth maxWidth="lg">
        <DialogTitle>
          <Typography component="h2" variant="h2" gutterBottom>
            {t('actions.status.change')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Trans
            i18nKey="messages.submission.status.send"
            values={{
              fromStatus: t('submission.status.ready.to.send'),
              toStatus: t('submission.status.sent'),
            }}
          />
        </DialogContent>
        <SubmissionTable submissions={sendSubmissionDialog.values} view={view} />
        <DialogActions>
          <Button data-testid="cancel" color="default" onClick={sendSubmissionDialog.close}>
            {t('actions.cancel')}
          </Button>
          <Button id="delete" color="primary" onClick={sendSubmissionDialog.confirm(sendSubmissionDialog.values)}>
            {t('actions.send.submission')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SendSubmissionDialog;
